import {React} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


export default function  HooksInput(props) {
  return (
    <Autocomplete
      fullWidth
      onChange={(event, newValue) => {
        props.hooks(newValue);
      }}
      id="controllable-states-demo"
      options={options}
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Hooks"
        />
      )}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const options = ["None", "Legacy", "First Generation", "Recruited Athlete", "Low-Income"];
